import {
  Typography,
  Card,
  CardHeader,
  CardContent,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
  Link as MuiLink,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAptorApi } from '../../../../Api';
import { Loading, HtmlView } from '../../../../Components';
import { debug } from 'console';

interface IInformationBoard {
  id: number;
  headline: string;
  message: string;
  url?: string;
  urlName?: string;
  visibleTo?: number;
  status?: boolean;
  createdAt?: string;
  createdBy?: number;
}

export const InformationBoardWidget = () => {
  const {formatMessage}= useIntl();
  const { api, abortController } = useAptorApi();
  const [informationBoard, setInformationBoard] = useState<IInformationBoard[]>();

  useEffect(() => {
    api.getDashboardAnnouncements<IInformationBoard>().then((result:any) => {
      if (abortController.current.signal.aborted) {
        return;
      }
      setInformationBoard(result);
    });
  }, [api, abortController]);


  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h3">
            <FormattedMessage id="law-portal.dashboard.informationBoard" />
          </Typography>
        }
      />
      <CardContent style={{padding:'10px 40px'}}>
          {(informationBoard === undefined && <Loading />) || (
         informationBoard?.map((item, index) => (
          <ExpansionPanel key={item.id} style={{marginBottom:'10px'}} defaultExpanded={index === informationBoard.length - 1}>
            <ExpansionPanelSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6">{item.headline}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container direction="column"  style={{ width: '100%' }}>
                <Grid item>
                  <HtmlView variant="body2" value={item.message} />
                </Grid>
                <Grid item>
                  <MuiLink href={item.url} target="_blank" rel="noopener noreferrer">
                    {item.urlName||formatMessage({ id: "admin.law-portal.informationboard.form.urlName.placeholder" })}
                  </MuiLink>
                </Grid>
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
        ))
        )}
        
      </CardContent>
    </Card>
  );
};
